import { render, staticRenderFns } from "./VerifiablePhoneField.vue?vue&type=template&id=69863256&scoped=true"
import script from "./VerifiablePhoneField.vue?vue&type=script&lang=ts"
export * from "./VerifiablePhoneField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69863256",
  null
  
)

export default component.exports